import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/styles/index.scss";
import ElementUi from "element-ui";
import * as filters from "./filters";
import store from "@/store";
import i18n from "@/i18n";
import { mixin } from "@/mixin/index";
import VueDragResize from "vue-drag-resize";
import Contextmenu from "vue-contextmenujs";
import Mathjax from "@/components/mathJax/mathJax";
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "@/grid.css";
import htmlToPdf from "./utils/htmlToPdf.js";
import "./directive/index.js";
import QuitOperation from "./utils/overtime.js";

Vue.use(htmlToPdf);
Vue.use(VideoPlayer);
Vue.use(QuitOperation);

Vue.use(Contextmenu);
Vue.component("vue-mathjax", Mathjax);
Vue.component("vue-drag-resize", VueDragResize);

Vue.use(ElementUi, {
    i18n: (key, value) => i18n.t(key, value),
});
Vue.config.productionTip = false;

Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key]);
});
Vue.mixin({
    ...mixin,
});
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
